import React, { useMemo } from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";

import ComponentContext from "../../contexts/ComponentContext";
import { useStores } from "../../contexts/StoreContext";
import SearchResults from "../../shared/components/SearchResults/SearchResults";

function SingleVenueHero() {
  const { venuePageStore } = useStores();
  const { venueId, venueProfile } = venuePageStore;

  const searchResultProps = useMemo(
    () => ({
      additionalConfig: {
        disableBrowseButton: true,
        disableClearFilters: true,
        selectedVacancy: { backgroundColor: "#fff" },
        thumbnail: { backgroundColor: "transparent" },
        vacancy: { backgroundColor: "white" },
      },
      formHeaderBackgroundColor: "#FF7C1C",
      predefinedFilters: [
        {
          filterName: "companyId",
          filterValue: venueId,
        },
      ],
      thumbnail: {
        data: { attributes: { url: venueProfile?.logoFullUrl || null } },
      },
      type: "withThumbnail",
    }),
    [venueProfile.logoFullUrl, venueId]
  );

  return (
    <ComponentContext.Provider value={searchResultProps}>
      <SearchResults />
    </ComponentContext.Provider>
  );
}

export default observer(SingleVenueHero);

SingleVenueHero.defaultProps = {
  profile: null,
};

SingleVenueHero.propTypes = {
  profile: PropTypes.shape({
    logoFullUrl: PropTypes.string,
  }),
};
